export enum ContractApiRoutes {
  ActivityLogs = '/contracts/:id/activity-logs',
  AvailableCancelReasons = '/contracts/:id/available-cancel-reasons',
  AvailableWaitingPeriods = '/contracts/:id/available-waiting-periods',
  AvailableSurchargesAndOptions = '/contracts/:id/available-surcharges-and-options',
  ById = '/contracts/:id',
  ByIdBase = '/contracts/:id/base',
  RequestTransfer = '/contracts/:id/request-transfer',
  CalculateProRatedRefund = '/contracts/:id/calculate-pro-rated-refund',
  CancelFlat = '/contracts/:id/cancel-flat',
  CancelNonPay = '/contracts/:id/cancel-nonpay',
  CancelOwnershipTransfer = 'contracts/:id/cancel-ownership-transfer',
  Cart = 'contracts/:id/cart',
  CollectedSurcharge = '/contracts/:id/collected-surcharge',
  CompleteCancellation = '/contracts/:id/complete-cancellation',
  ConfirmRefund = '/contracts/:id/confirm-refund',
  CreateConsumerFromContract = '/contracts/:id/create-consumer',
  CreateRetention = 'contracts/:id/create-retention',
  ContractRetention = '/contracts/:id/retention',
  ContractCollections = '/contracts/:id/collections',
  CsRequestRefundCanceled = '/contracts/:id/request-refund-canceled',
  CsUpdateMileage = '/contracts/:id/adjustments/cs-mileage',
  DetailsByPhone = '/contracts/details-by-phone',
  DownloadLoc = '/contracts/:id/download-loc-form',
  DownloadLocCancelOdometerScreenshot = '/contracts/:id/download-loc-cancel-odometer-screenshot',
  DownloadTransferOfOwnershipForm = '/contracts/:id/download-transferofownership-form',
  DownloadProRatedRefundBreakdown = '/contracts/:id/download-pro-rated-refund-breakdown',
  FulfillmentHistory = '/contracts/:id/fulfillment-events',
  FulfillmentLanguage = '/contracts/:id/fulfillment-language',
  FullFundedDetails = '/contracts/:id/full-funded-refund-details',
  FullFundedRefundApproval = '/contracts/:id/full-funded-refund/approve',
  FullFundedRefundCalculate = '/contracts/:id/full-funded-refund/calculate',
  FullFundedRefundInitiate = '/contracts/:id/full-funded-refund/initiate',
  FullFundedRefundIssue = '/contracts/:id/full-funded-refund/issue',
  GeneratePdf = '/contracts/:id/generate-pdf',
  IssueAdditionalRefund = '/contracts/:id/issue-additional-refund',
  PatchCancelDetails = '/contracts/:id/cancel-details',
  Pdf = '/contracts/:id/pdf',
  ProcessDownPayment = '/contracts/:id/process-payment',
  ProRatedRefund = '/contracts/:id/issue-refund',
  ProRatedRefundBreakdown = '/contracts/:id/pro-rated-refund-breakdown',
  ProRatedRefundDetails = '/contracts/:id/pro-rated-refund-details',
  Reinstate = '/contracts/:id/reinstate/',
  Reprint = 'contracts/:id/resend',
  RequestCancellation = '/contracts/:id/request-cancellation',
  ReverseCancellation = '/contracts/:id/reverse-cancellation',
  Saves = 'contracts/:id/saves',
  SendPrrBreakdown = '/contracts/:id/pro-rated-refund-send-email',
  SendRoadsideAssistanceInfo = '/contracts/:id/roadside-assistance-info-send-email',
  StopOwnershipTransfer = 'contracts/:id/stop-ownership-transfer',
  SyncToMoxy = '/contracts/:id/sync-to-moxy',
  RetransmitToAdmin = '/contracts/:id/retransmit-to-admin',
  TrackContractOpen = '/contracts/:id/opened',
  Transactions = '/contracts/:id/finance',
  UploadedDocuments = '/contracts/:id/uploaded-documents',
  DownloadContractDocument = '/contracts/:id/documents/:documentId/download',
  Transfer = '/contracts/:id/transfer',
  TransferDetails = '/contracts/:id/transfer-details',
  UpdateAdditionalPolicyHolders = '/contracts/:id/additional-policy-holders',
  UpdateCancelEvent = '/contracts/:id/cancel-event',
  UpdatePolicyAddress = '/contracts/:id/policy-address',
  UpdateEmail = '/contracts/:id/email',
  UpdateMailingAddress = '/contracts/:id/mailing-address',
  UpdatePhone = '/contracts/:id/phone',
  UpdateSdr = '/contracts/:id/sdr',
  UpdateSalesAdjustment = '/contracts/:id/sales-adjustment',
  UpdateSoldByRep = '/contracts/:id/sold-by-rep',
  UpdateSoldDate = '/contracts/:id/sold-date',
  UpdateWaitingPeriod = '/contracts/:id/update-waiting-period',
  UpdateMonthlyPayment = '/contracts/:id/monthly-payment',
  UpdateDownPayment = '/contracts/:id/down-payment',
  UpdateVinAndMileage = '/contracts/:id/adjustments/vin-and-mileage',
  UploadLoc = 'contracts/:id/upload-loc-form',
  UploadTransfer = 'contracts/:id/upload-transferofownership-form',
  UpdatePolicyHolder = 'contracts/:id/policy-holder',
  AdjustmentPolicyById = 'contracts/:id/adjustments/policy',
  AdjustmentDiffContractById = 'contracts/:id/adjustments/diff',
  ApplyAdjustment = '/contracts/:id/adjustments/apply',
  Adjustments = '/contracts/:id/adjustments/:id',
  CalculateAdjustmentPlanPaymentDetails = '/contracts/:id/adjustments/calculate-payment-details',
  RemoveAchRefund = '/contracts/:id/remove-ach-refund',
  CreateCollectionReporting = '/contracts/:id/create-collection',
  UpdateCollectionReporting = '/contracts/:id/collection',
}
